export class StatsDisplay {
    constructor(containerId) {
        this.stats = null;
        this.mode = 'time';
        this.config = null;
        this.lastErrors = 0;
        const container = document.getElementById(containerId);
        if (!container) {
            throw new Error(`Container with id "${containerId}" not found`);
        }
        this.container = container;
    }
    updateStats(stats, mode, config) {
        this.stats = stats;
        this.mode = mode;
        this.config = config;
        this.render();
        this.lastErrors = stats.errors;
    }
    render() {
        if (!this.stats || !this.config)
            return;
        const remainingTime = this.mode === 'time' && this.config.duration
            ? Math.max(0, Math.round(this.config.duration - this.stats.duration))
            : null;
        const remainingWords = this.mode === 'words' && this.config.wordCount
            ? Math.max(0, this.config.wordCount - (this.stats.wordsCompleted ?? 0))
            : null;
        // Minimal inline stats - only show when test is active
        if (!this.stats || this.stats.duration === 0) {
            this.container.innerHTML = '';
            return;
        }
        this.container.innerHTML = `
      <div class="flex flex-wrap items-center gap-4 md:gap-6">
        <div class="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm hover:border-yellow-400/30 transition-all duration-300 hover:scale-105">
          <span class="text-gray-400 text-base md:text-lg">SMM</span>
          <span class="text-yellow-400 font-bold text-xl md:text-2xl lg:text-3xl">${Math.round(this.stats.wpm)}</span>
        </div>
        <div class="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm hover:border-yellow-400/30 transition-all duration-300 hover:scale-105">
          <span class="text-gray-400 text-base md:text-lg">Täpsus</span>
          <span class="text-green-400 font-bold text-xl md:text-2xl lg:text-3xl">${Math.round(this.stats.accuracy)}%</span>
        </div>
        <div class="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm hover:border-red-400/30 transition-all duration-300 hover:scale-105">
          <span class="text-gray-400 text-base md:text-lg">Vead</span>
          <span class="text-red-400 font-bold text-xl md:text-2xl lg:text-3xl ${this.stats.errors > (this.lastErrors || 0) ? 'animate-shake' : ''}">${this.stats.errors}</span>
        </div>
        ${remainingTime !== null ? `
          <div class="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm hover:border-blue-400/30 transition-all duration-300 hover:scale-105">
            <span class="text-gray-400 text-base md:text-lg">Aeg</span>
            <span class="text-blue-400 font-bold text-xl md:text-2xl lg:text-3xl">${remainingTime}s</span>
          </div>
        ` : ''}
        ${remainingWords !== null ? `
          <div class="flex items-center gap-2 px-4 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm hover:border-purple-400/30 transition-all duration-300 hover:scale-105">
            <span class="text-gray-400 text-base md:text-lg">Sõnad</span>
            <span class="text-purple-400 font-bold text-xl md:text-2xl lg:text-3xl">${remainingWords}</span>
          </div>
        ` : ''}
      </div>
    `;
    }
}
